

<!-- <div class="" role="banner">
  <div class="main" [innerHTML]="UserMenu"></div>
</div>

<router-outlet></router-outlet> 
<div class="content" role="main">

</div>
<footer>glkdfngklfndgkndfkgjnk</footer> -->


<!-- <div class="" role="banner">
  <div>
    <img width="40" class="page-logo" alt="Sharp Logo" src="../assets/Content/Imgs/sharplogo.gif"  />    
  </div>  
    <div class="main" [innerHTML]="UserMenu"></div>
</div> -->


<nav class="navbar navbar-light bg-light" *ngIf="Header!=1">
  <div class="col-sm-12">
    <img width="40" class="page-logo" alt="Sharp Logo" src="../assets/Content/Imgs/sharplogo.gif"  />    
    <span *ngIf="utility.user" class="username">Hi! <b> {{utility.user.employeeName}} </b> [{{utility.user.officeName}}] 
      
      <i (click)="LogOut()" class="fa fa-sign-out fa-2x pl-2" aria-hidden="true"></i>
    </span>
    
  </div>
  <div class="main" [innerHTML]="userMenu"></div>
</nav>
<div class="content">
  <div class="row" >
    <div class="col-sm-12">
      
      <router-outlet></router-outlet> 
    </div>
    
  </div>

</div>


<!-- <footer>
  
  <div class="row">
    <div class="col-md-3 col-sm-6 col-xs-12 footer-block">
      <h3>Infoman ERP</h3>
      <p>
         Infoman ERP for SBSIL
      </p>
    </div>
    <div class="col-md-3 col-sm-6 col-xs12 footer-block">
      
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12 footer-block">
      
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12 footer-block">
      <h3>Application Support</h3>
      <address class="margin-bottom-40">
      Phone: 0120 - 3358885<br>
              Contact: Amit Kumar<br>
      Email: <a href="mailto:amitkumar@sharp-oa.com">amitkumar@sharp-oa.com</a>
      </address>
    </div>
  </div>

</footer>
 -->
